module.exports = __webpack_public_path__ + "img/cup_sq.d01104d9.svg";